var _circle, _path, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageSubjectWorld = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.406,
  cy: 17.594,
  r: 13.094,
  transform: "rotate(180 17.406 17.594)",
  stroke: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "homepage_subject_world_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 9,
  width: 30,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.469 26.969-1.407 3.75-5.624 1.406L1 19.937l3.281-6.093 5.157-.469 2.812 3.281-.938 5.157 5.157 5.156ZM24.906 25.563v2.343l.469 1.407L31 23.218 29.125 19l-3.281-1.406v.937l-1.875 3.75-3.75-.937.937 3.75 3.75.468ZM26.313 14.781l-.47 2.344H20.22l-.469-3.75-1.875-.938 4.219-3.28 2.812.937-.468 1.875 1.875 2.812Z",
  fill: "#FFF"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#homepage_subject_world_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 13.5,
  transform: "rotate(180 17.5 17.5)",
  fill: "#FFF"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.406,
  cy: 17.594,
  r: 12.594,
  transform: "rotate(180 17.406 17.594)",
  stroke: "#FFF",
  strokeWidth: 2
})));
export default SvgHomepageSubjectWorld;